import { BackButton } from "components/parts/BackButton";
import { TextWithIconButton } from "components/parts/Button/TextWithIconButton";
import { TextWithIconTypes } from "components/parts/Button/TextWithIconButton/TextWithIconButton";
import { Typography } from "components/parts/Typography/Typography";
import { GroupList } from "pages/GroupManagement/GroupList";
import { GroupManageModal } from "pages/GroupManagement/GroupManageModal";
import { useConsoleState } from "providers/ConsoleStateProvider";
import { useLoadingState } from "providers/LoadingProvider";
import React, { useEffect } from "react";
import { ConsoleRoleType, Group } from "types/graphqlapi";

import { useGroupList } from "./hook";
import {
  StyledGroupManagementContainer,
  StyledButtonArea,
  StyledHeadline,
  StyledGroupListWrapper,
} from "./styled";

export const GroupManagement: React.FC = () => {
  const { setLoading } = useLoadingState();
  const [groupList, fetchGroups] = useGroupList();
  const { setGroup } = useConsoleState();
  const [selectedGroup, setSelectedGroup] = React.useState<Group>();

  useEffect(() => {
    setGroup("", "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ユーザーロール
  const { role } = useConsoleState();
  const clearSelectedGroup = () => {
    setSelectedGroup(undefined);
    setLoading(false);
    fetchGroups();
  };
  const selectGroup = (group: Group) => {
    setSelectedGroup(group);
  };
  const createNewGroup = () => {
    selectGroup({} as Group);
  };

  return (
    <>
      <BackButton />
      <StyledGroupManagementContainer>
        <StyledHeadline>
          <Typography size="xxlarge" weight={"bold"} text="グループ" />
          <StyledButtonArea>
            {role === ConsoleRoleType.ADMINISTRATOR && (
              <TextWithIconButton
                onClick={createNewGroup}
                text="新規グループ"
                variant={"primary"}
                iconName={TextWithIconTypes.Plus}
              />
            )}
          </StyledButtonArea>
        </StyledHeadline>
        <StyledGroupListWrapper>
          {groupList ? (
            <GroupList groupList={groupList} selectGroup={selectGroup} />
          ) : (
            "グループがありません"
          )}
          {selectedGroup && (
            <GroupManageModal
              closeHandler={clearSelectedGroup}
              selectedGroup={selectedGroup}
              clearSelectedGroup={clearSelectedGroup}
            />
          )}
        </StyledGroupListWrapper>
      </StyledGroupManagementContainer>
    </>
  );
};
